module.exports = { 
    navConstants : {
        hoverTextPath: "UrlAddress",//for nav links
        hoverText: {//for display links
            urlHoverTextPath : "Metadata.UrlAddress",
        },
        suppressTab: {
            operator: "equal",
            statePath: "Survey.visible",
            value: "true",
        },
    },
};


// WEBPACK FOOTER //
// ./settings/nav-constants.js